import React, {useContext} from 'react';
import {Button, Paper, Slide, Typography, Zoom} from "@mui/material";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {useHistory} from "react-router-dom";
import moment from "moment";
import {blue} from "@mui/material/colors";
import {useTheme} from "@mui/material/styles";
import {formatText} from "../../../../widgets/chat/ChatFab";
import {ChatContext} from "../../../../../App";

export const MessaggiPaper = () => {
	const classes = innerStyle();
	let theme = useTheme();
	let history = useHistory();
	const chatContext = useContext(ChatContext);
	
	return (
		<React.Fragment>
			<Slide direction={"up"} in={true} mountOnEnter unmountOnExit style={{transitionDelay: "500ms"}}>
				<Paper className={classes.paper} component={"section"}>
					<Typography variant={"h6"} style={{paddingLeft: 6}}>
						<b>Messaggi</b>
					</Typography>
					<Typography variant={"subtitle2"} color={"textSecondary"} style={{paddingLeft: 6}}>
						Visualizza i messaggi dall'ICT
					</Typography>
					<div className={classes.flexStart}>
						
						{
							chatContext.state.notification_sse?.map((item, index) => {
								return (
									<div key={index} className={classes.flexStart} style={{width: "100%", marginTop: 0}}>
										<Zoom in={true} style={{transitionDelay: "500ms"}}>
											<Typography className={classes.messageItem} variant={"caption"} style={{fontSize: 14}}>
												{formatText(item.notification)}
											</Typography>
										</Zoom>
										<Zoom in={true} style={{transitionDelay: "1s"}}>
											<Typography variant={"caption"} style={{
												backgroundColor: theme.palette.mode === "light" ? blue[600] : blue[50],
												color: theme.palette.mode === "light" ? blue[50] : blue[600],
												borderRadius: 20,
												padding: 4,
												marginTop: -20,
												marginLeft: 20,
												marginBottom: 12,
												fontSize: 10
											}}>
												{moment(new Date(item.date)).format("HH:mm - DD/MM/YYYY")}
											</Typography>
										</Zoom>
									</div>
								
								)
							})
						}
					</div>
					<div className={classes.flexEnd}>
						<Button className={classes.button} style={{borderRadius: 22}} variant={"contained"} disableElevation
						        onClick={() => history.push("/v2/gestione/messaggi")}>
							<b>Mostra tutti i messaggi</b>
						</Button>
					</div>
				</Paper>
			</Slide>
		</React.Fragment>
	);
};
